import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import BreakOutContainer from '../break-out-container/break-out-container';
import DynamicImage from '../dynamic-image/dynamic-image';
import EmbedMedia from '../embed-media/embed-media';
import type { ArticlePageHeader as Props } from './article-page-header.types';

const ArticlePageHeader: React.FunctionComponent<Props> = ({
  image,
  media,
  shouldBreakOut,
  title,
}) => {
  const MediaWrapper = shouldBreakOut ? BreakOutContainer : React.Fragment;

  return (
    <div className="article-page-header">
      {title ? (
        <Text
          className="article-age-header__title"
          elementName="h1"
          size={Text.sizes.headline2}
          theme={Text.themes.headline}
          italic
        >
          {title}
        </Text>
      ) : null}

      {image || media ? (
        <MediaWrapper>
          <div className="article-page-header__media">
            {image ? (
              <DynamicImage
                aspectRatio={DynamicImage.aspectRatios.sixteenNine}
                {...image}
              />
            ) : null}
            {media ? (
              <EmbedMedia
                theme={
                  shouldBreakOut ? EmbedMedia.themes.paddedButtons : undefined
                }
                {...media}
              />
            ) : null}
          </div>
        </MediaWrapper>
      ) : null}
    </div>
  );
};

export default ArticlePageHeader;
